import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { NoticeEffects } from "./+state/effects";
import { NoticeFacade } from "./+state/facades";
import { NOTICE_FEATURE_KEY, noticeReducer } from "./+state/reducers";

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([NoticeEffects]),
    StoreModule.forFeature(NOTICE_FEATURE_KEY, noticeReducer)
  ],
  providers: [NoticeFacade]
})
export class NoticeDataAccessModule {}
